import { last, mean } from 'lodash-es';
import { makeRangeMatcher } from '../utils';

export const heatColors = ['#EDF5FD', '#D6E8F9', '#AED1F4', '#85BAEE', '#5DA3E9'];
const trendColors = {
  UP: '#5DA3E9',
  GROWING: '#85BAEE',
  SLOWING: '#AED1F4',
  FLAT: '#D6E8F9',
  DOWN: '#EDF5FD',
};

const getDataFields = (point, avgRowValue, matchRange) => {
  if (!point) return {};

  const pointValue = parseFloat(point);

  if (Number.isNaN(pointValue)) {
    console.log('trendColors[point]', trendColors[point]);
    return {
      value: point,
      color: trendColors[point],
    };
  }

  return {
    value: pointValue,
    color: heatColors[matchRange.findIndex((isMatch) => isMatch(pointValue))],
  };
};

export const makeChartConfig = ({ x_axis_categories, y_axis_categories, data, numbersRange }) => {
  const rangeMatcher = makeRangeMatcher(numbersRange);

  const reversedData = [...data].reverse();
  const chartData = y_axis_categories
    .map((yCat, yIndex) => {
      const rowNumberValues = reversedData[yIndex].reduce((result, item) => {
        const numberValue = parseFloat(item);
        return Number.isNaN(numberValue) ? result : result.concat(numberValue);
      }, []);
      const avgRowValue = Math.round(mean(rowNumberValues));

      return x_axis_categories.map((xCat, xIndex) => ({
        x: xIndex,
        y: yIndex,
        name: reversedData[yIndex][xIndex],
        fontSize: '12px',
        ...getDataFields(reversedData[yIndex][xIndex], avgRowValue, rangeMatcher),
      }));
    })
    .flat();

  return {
    chart: {
      type: 'heatmap',
      height: 66 * y_axis_categories.length + 45,
      width: 1046,
      spacing: [0, 0, 0, 0],
      style: {
        fontFamily: 'THICCCBOI',
      },
      accessibility: {
        enabled: false,
      },
    },
    credits: {
      enabled: false,
    },

    navigation: {
      buttonOptions: {
        enabled: false,
      },
    },

    lang: {
      accessibility: {
        enabled: false,
      },
    },

    title: {
      text: '',
    },

    xAxis: {
      crosshair: false,
      categories: x_axis_categories,
      labels: {
        style: {
          fontSize: '14px',
          color: '#7987A1',
        },
        useHTML: true,
        y: 30,
      },
    },

    yAxis: {
      crosshair: false,
      gridLineColor: 'transparent',
      categories: y_axis_categories,
      title: null,
      labels: {
        enabled: false,
      },
    },

    legend: {
      enabled: false,
    },
    legendSymbol: 'rectangle',

    dataLabels: {
      useHTML: true,
      style: {
        width: 63,
        height: 63,
      },
    },

    tooltip: {
      enabled: false,
    },

    series: [
      {
        type: 'heatmap',
        name: '',
        pointPadding: 4,
        borderRadius: 16,
        data: chartData,
        states: {
          hover: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
          fontSize: 13,
          style: {
            padding: [35, 0, 35, 0],
            color: '#1A2340',
            fontSize: '13px',
            fontWeight: '400',
          },
          useHTML: true,
          formatter() {
            return last(this.key) !== '%'
              ? `<span style="font-size: 12px">${this.key}</span>`
              : this.key;
          },
        },
      },
    ],
  };
};
